import Logo from "components/Logo";

// import { FaFacebook, FaInstagram, FaLinkedin, FaTwitter } from "react-icons/fa";

const DashboardFooter = () => {
  const date = new Date(Date.now());
  return (
    <footer className="h-fit md:h-[60px] shrink-0 py-5 bg-header/40 w-full flex flex-col  md:flex-row md:justify-between items-center">
      <div className="flex items-center px-5 space-x-5 ">
        <Logo className=" w-10 h-10" />
        <span> KAUST GUARDIAN - UIS {date.getFullYear()} &copy;</span>
      </div>
      {/* <div className="px-5 pt-5 md:pt-0 space-x-5 flex">
        <FaTwitter className="w-5 h-5" />
        <FaFacebook className="w-5 h-5" />
        <FaInstagram className="w-5 h-5" />
        <FaLinkedin className="w-5 h-5" />
      </div> */}
    </footer>
  );
};

export default DashboardFooter;
